<script lang="ts">

import {defineComponent, ref, onMounted, type PropType} from 'vue';
import {translation, useTranslationStore} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  name: 'TravelOfferCoverageCard',
  props: {
    icon: {
      type: String,
      required: true,
    },
    textBody: {
      type: String,
      required: true,
    },
    isIncluded: {
      type: Boolean,
      required: true,
    },
    maxCoverage: {
      type: [String, null] as PropType<string | null>,
      required: true,
    },
  },
  setup(props) {
    const translationStore = useTranslationStore();
    const translationList = ref<TranslationList>({});

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
    });

    const textStyle = computed(() => ({
      color: props.isIncluded ? 'rgba(var(--v-theme-tertiary-accent))' : 'rgba(var(--v-theme-disabled-dark))',
    }));

    return {
      textStyle,
      translationList,
      translation,
    };
  },
});
</script>

<template>
  <div class="pa-1 card-max-size">
    <v-hover>
      <template v-slot:default="{ isHovering, props }">
        <v-card
            v-bind="props"
            flat
            rounded="0"
            :color="isIncluded ? 'tertiary-light' : 'disabled-light'"
            class="h-100 d-flex flex-column align-center justify-center"
        >
          <v-icon class="pa-5" :icon="icon" :color="isIncluded ? 'tertiary-accent' : 'disabled-dark'"></v-icon>

          <div class="d-flex justify-center my-auto px-2 w-100" style="overflow: hidden; white-space: normal;">
            <span class="text-center fs-400 fs-14" :style="textStyle">
              {{ textBody }}
            </span>
          </div>

          <v-icon class="pa-5" :icon="isIncluded ? 'mdi-check-bold' : 'mdi-close-thick'"
                  :color="isIncluded ? 'tertiary-accent' : 'disabled-dark'"></v-icon>

          <v-tooltip
              activator="parent"
              location="top"
              :content-class="isIncluded ? 'tooltip-included' : 'tooltip-not-included'"
          >
            <div class="pa-2 fw-700 fs-16" :class="isIncluded ? 'color-tertiary-accent' : 'text-contrast'">
              <div v-if="isIncluded">
                {{ translation(translationList.max_coverage_amount, 'Suma maxima asigurata') }}:
                {{ maxCoverage }} Euro
              </div>
              <div v-else>
                {{ translation(translationList.not_included, 'Nu este inclus') }}
              </div>
            </div>
          </v-tooltip>

          <div
              v-if="isHovering"
              class="overlay cursor-pointer"
          ></div>
        </v-card>
      </template>
    </v-hover>
  </div>
</template>

<style scoped>

.card-max-size {
  min-height: 150px !important;
  max-height: 150px !important;
  min-width: 103px !important;
  max-width: 103px !important;
}

</style>